import React from "react";

const Staffing = () => {
  return (
    <section className="bg-white px-6 md:px-16 py-12 border-b-2 ">
      <div className="max-w-5xl mx-auto text-gray-800 text-lg leading-relaxed rounded-2xl border shadow-lg p-8">
        <h2 className="text-3xl font-bold text-emerald-700 mb-6">
          CONTRACT STAFFING / OUTSOURCING
        </h2>

        <p className="mb-6 text-justify">
          Human resource management regards training and development as a
          function concerned with organizational activities aimed at improving
          the job performance of individuals and groups within organizational
          settings. Training and development can be described as an educational
          process that involves sharpening skills, enhancing concepts, changing
          attitudes, and gaining knowledge to boost employee performance.
        </p>

         <p className="mb-4">
          We provide skilled candidates with expertise in engineering system
          design across various domains.<br/> Our key areas of specialization
          include:
        </p>

        <ol className=" list-disc list-inside mb-6 pl-4">
          <li>Automobile Industry.</li>
          <li>Electrical Power Systems.</li>
          <li>Civil Construction Machinery and Vehicles.</li>
          <li>Domestic and Industrial Machines.</li>
          <li>2D/3D Harness Modeling and Routing.</li>
        </ol>

      </div>
    </section>
  );
};

export default Staffing;
